import React from "react"
import PropTypes from "prop-types"
import Card from "@mui/material/Card"
import Divider from "@mui/material/Divider"
import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"

interface FacilityCardProps {
  icon: string
  title: string
  value?: string | number
  iconDetection: boolean
  iconAlert: boolean
  iconNoDevice: boolean
  catv_logo?: string
  catv_name?: string
  onClick?: () => void
}

const FacilityCard: React.FC<FacilityCardProps> = ({
  icon,
  title,
  value,
  iconDetection,
  iconAlert,
  iconNoDevice,
  catv_logo,
  catv_name,
  onClick
}) => {
  // unset が無い
  const color = iconAlert ? "primary" : iconDetection ? "warning" : iconNoDevice ? "info" : "success"

  return (
    <Card
      sx={{
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 10px 20px rgba(0,0,0,0.1)"
        },
        display: "flex !important",
        flexDirection: "row !important",
        overflow: "hidden",
        height: "100%"
      }}
      onClick={onClick}
    >
      <MDBox
        width="30%"
        height="100%"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        bgColor={color == "success" ? "white" : color}
        variant={color == "success" ? "contained" : "gradient"}
      >
        <Icon
          sx={{
            color: color == "success" ? `${color}.main` : "white !important",
            fontSize: "2.5rem !important"
          }}
        >
          {icon}
        </Icon>
        {catv_logo && <MDBox mt={1} component="img" src={catv_logo} alt="Brand" maxWidth="80%" maxHeight="30px" />}
      </MDBox>
      <MDBox width="70%">
        <MDBox pb={1} px={2} textAlign="center" lineHeight={1.25}>
          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            {title}
          </MDTypography>
          {value && (
            <MDTypography variant="caption" color="text" fontWeight="regular">
              {value}
            </MDTypography>
          )}
          {catv_name ? <Divider sx={{ padding: "0", margin: "0" }} /> : null}
          {catv_name && (
            <MDTypography variant="caption" color="text" fontWeight="regular">
              {catv_name}
            </MDTypography>
          )}
        </MDBox>
      </MDBox>
    </Card>
  )
}

FacilityCard.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  onClick: PropTypes.func
}

export default FacilityCard
